import '..//..//..//mixins.js'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
import { mapGetters } from 'vuex'

export default {
  name: 'diversification',
  components: {spinner},
  data() {
    return {
      responseData : null,
      showSpinner: false,
      regionWeights: null,
      diversification: [],
      id : this.$route.params.id,
      PortfolioEmpty : false
    }
  },
  created(){

  },
  beforeMount () {

  },
  mounted () {
    this.loadData();
    window.addEventListener("resize", this.myEventHandler);

  }, 
  computed: {
    ...mapGetters(['get_SP_portfolioData'])
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler() {
      var activeTab;
      activeTab = this.getActiveTab("nav-bar-diversification");
      this.accessDiversificationByKey(activeTab, 'diversification');
    },

    loadData: async function() {
      this.showSpinner = true;
        this.diversification = this.get_SP_portfolioData["diversification"]
        this.accessDiversificationByKey('security', 'diversification');
    },
    accessDiversificationByKey: function(key, divName){
      if (Object.keys(this.diversification).length === 0){
        this.PortfolioEmpty = true;
      }
      else{
        var requestedDiversificationData = this.diversification[key];
        this.plotPieChart(requestedDiversificationData, divName);
        this.buttonActivation("nav-bar-diversification", "btn");
      }
      this.showSpinner = false;
    }
  }
}